<template>
  <InteractionStep :disabled-next="isDisabledNext"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-accept-received-files">
        <img src="../../../assets/img/svg/interaction/accept-received-files.svg"
             alt="accept-received-files"
             class="step-accept-received-files__img">

        <BaseRadioList v-model="value"
                       :options="list"
                       textKey="title"
                       class="step-accept-received-files__list"/>
      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '@/axios'
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionAcceptReceivedFiles',
    mixins: [interactionStepMixin],
    props: {
      checkText: String
    },
    data(vm) {
      return {
        value: null,
        pendingSave: false,
        error: null,
        list: [{
          id: 1,
          title: vm.checkText
        }]
      }
    },
    components: {
      InteractionStep
    },
    computed: {
      isDisabledNext() {
        return !this.value
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const id = this.$route.params.id
        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${id}/${step}`, {
          go_next: true
        }).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction');
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      }
    }
  }
</script>

<style>

</style>
